import { useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import {
    useRecordContext,
    useGetOne,
    useGetList
} from "react-admin";
import { WorkflowExecution  } from "../../../../types/entities";
import { CronExpressionParser } from 'cron-parser';


export const WorkflowExecutionSettingsPanel: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const record: WorkflowExecution = useRecordContext();
    const [activeExecution, setActiveExecution] = useState<WorkflowExecution>();
    let filter = {};
    if (record) {
        filter = { 'workflow': record.id }
    }
    const { data: workflowExecutions, isPending, error } = useGetList('workflow_executions', {
        filter: filter
    });

    function getWorkflowExecutionName(key: string, convertCronFormat: boolean = false): string {
        let returnName = '';
        let workflowExecution = undefined;
        if (workflowExecutions.length > 0) {
            workflowExecution = workflowExecutions[0];
        }
        if (workflowExecution !== undefined) {
            returnName = workflowExecution[key];
        }
        if (convertCronFormat) {
            if (!returnName.includes('#') && returnName !== '') {
                // returnName = returnName.replaceAll('#', 'H')
                returnName = CronExpressionParser.parse(returnName, {
                    tz: 'Europe/London',
                }).next().toString()

            } else {
                returnName = '';
            }

        }

        return returnName;
    }

    function handleEditExecutionClick(): void {
        if (activeExecution === undefined) {
            context.toggleWorkflowExecutionSettingsModal(true);
        } else {
            context.setWorkflowExecutionSettings(activeExecution);
        }

    }

    useEffect( (): void => {
        if (workflowExecutions !== undefined && workflowExecutions.length > 0) {
            setActiveExecution(workflowExecutions[0]);
        }
    }, [workflowExecutions] );


    return (
        <div className="workflow-settings__bottom">
            <span className="bottom__title" >{ "Execution Settings" }</span>
            { (context.mode === 'edit') &&
                <div className="settings">
                    { (isPending) &&
                        <div className="settings__loader">
                            <span>Loading Execution Settings...</span>
                        </div>
                    }
                    { (error) &&
                        <div className="settings__error">
                            <span>Loading Execution Settings Error...</span>
                        </div>
                    }
                    { (workflowExecutions) &&
                        <>
                            <div className="settings__settings">
                                <div className="settings__item">
                                    <span className="settings__label">{ "Name:" }</span>
                                    <span className="settings__value">{ getWorkflowExecutionName('name') }</span>
                                </div>
                                <div className="settings__item stack">
                                    <span className="settings__label">{ "Cron Expression:" }</span>
                                    <span className="settings__value">{ getWorkflowExecutionName('cronExpression') }</span>
                                </div>
                                { (getWorkflowExecutionName('cronExpression', true) !== '') &&
                                    <div className="settings__item stack">
                                        <span className="settings__label">{ "Next Execution:" }</span>
                                        <span className="settings__value">{ getWorkflowExecutionName('cronExpression', true) }</span>
                                    </div>
                                }
                            </div>
                            <div className="settings__edit">
                                <span className="edit__button" onClick={ handleEditExecutionClick } >{ "Edit" }</span>
                            </div>
                        </>
                    }
                </div>
            }
            { (context.mode !== 'edit') &&
                <span className='save-message'>{ "Please save the workflow to see the execution settings" }</span>
            }
        </div>
    );
}